import {
  commonFormFieldProps,
  requiredRule,
} from "@/app/fields/commonFormFieldProps";
import { Entity, INumberField } from "@/app/fields/types";
import { useGetNumberAddons } from "@/app/hooks/useGetNumberAddons";
import { useFormContext } from "@saas-ui/forms";
import { Field } from "@saas-ui/react";
import { ReactElement, useEffect } from "react";

export const NumberFormField = <T extends Entity>({
  field,
  isDisabled,
}: {
  field: INumberField<T>;
  isDisabled?: boolean;
}): ReactElement => {
  const fieldName = String(field.field);
  const getNumberAddons = useGetNumberAddons<T>();
  const { watch, setValue } = useFormContext();
  const changedValue = watch(fieldName);
  useEffect(() => {
    if (["", undefined, null].includes(changedValue)) {
      return;
    }
    const asString = `${changedValue}`.replaceAll(",", "");
    const asNumber = parseInt(asString);
    if (isNaN(asNumber)) {
      return;
    }
    setValue(fieldName, asNumber.toLocaleString());
  }, [changedValue]);
  return (
    <Field
      isDisabled={isDisabled}
      type="text"
      pattern="\b\d[\d,.]*\b"
      label={field.label}
      {...commonFormFieldProps(field)}
      rules={requiredRule(field)}
      {...getNumberAddons(field)}
    />
  );
};
